import React from 'react';
import { Coins } from 'lucide-react';
import { TIPPING_DATA, getCountryData } from '@/data/essentials';

const LABELS = {
  restaurants: 'Restaurants',
  taxi:        'Taxi & rideshare',
  porter:      'Porter / bellhop',
  salon:       'Salon / spa',
  hotel_maid:  'Hotel housekeeping',
  guide:       'Tour guide',
};

export default function TippingCard({ countryCode, countryName }) {
  const d = getCountryData(TIPPING_DATA, countryCode);
  return (
    <div className="puvio-card p-5" data-testid="tipping-card">
      <div className="flex items-start justify-between">
        <div>
          <p className="font-bold text-[11px] uppercase tracking-[0.22em] text-[var(--puvio-mint-deep)]">Tipping etiquette</p>
          <p className="text-xs text-[var(--puvio-text-2)] mt-0.5 font-medium">{countryName || 'Local norms'}</p>
        </div>
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: '#FFF1C2' }}>
          <Coins className="w-6 h-6 text-[#B85F31]" />
        </div>
      </div>
      <ul className="mt-4 divide-y divide-[var(--puvio-border)]">
        {Object.entries(LABELS).map(([k, label]) => (
          d[k] ? (
            <li key={k} className="flex items-start justify-between gap-3 py-2" data-testid={`tipping-${k}`}>
              <span className="text-[12px] font-semibold text-[var(--puvio-text-2)] uppercase tracking-wide">{label}</span>
              <span className="text-[13px] font-bold text-[#0F1A13] text-right">{d[k]}</span>
            </li>
          ) : null
        ))}
      </ul>
      {d.note && <p className="text-[12px] text-[var(--puvio-text-2)] mt-3 leading-relaxed italic">{d.note}</p>}
    </div>
  );
}
